import { InjectionToken } from '@angular/core';
import { Duration } from 'moment';

export const enum CacheStoragesEnum {
  LOCAL_STORAGE = 1,
  SESSION_STORAGE = 2,
  MEMORY = 3,
  HYBRID = 4,
}

export interface ICacheOptions {
  preloadMaxAge?: Duration;
  cacheMaxAge?: Duration;
  tag?: string;
}

export interface INgCacheStoreOptions {
  cacheExpires?: number;
  preloadExpires?: number;
  tag?: string;
}

export interface INgCacheOptions extends INgCacheStoreOptions {
  cacheMaxAge?: number;
  preloadMaxAge?: number;
}

export interface ICacheInfo<TEntity> {
  value: TEntity;
  validForCache: boolean;
  validForPreload: boolean;
}

export interface ICacheLogger {
  error(error: string): void;
}
export const I_CACHE_LOGGER = new InjectionToken<ICacheLogger>('ICacheLogger');

export interface IStorageValue<TEntity> {
  value: TEntity;
  options: INgCacheStoreOptions;
}

export interface ITagsMap<TValue = string> {
  [tag: string]: TValue[];
}
